/**
 * Navigation configuration for the Expert Property Maintenance website.
 * Shared between desktop and mobile navigation components.
 */
export const NAVIGATION_ITEMS = [
  {
    name: 'Property Maintenance',
    href: '/reactive-property-maintenance',
    dropdown: [
      { name: 'Reactive Maintenance', href: '/reactive-property-maintenance' },
      { name: 'Planned Maintenance', href: '/planned-property-maintenance' },
      { name: 'Handyman Services', href: '/handyman-services' },
      { name: 'Carpentry & Joinery', href: '/carpentry-joinery' },
      { name: 'Painting & Decorating', href: '/painting-decorating' },
      { name: 'Plastering & Repairs', href: '/plastering-repairs' }
    ]
  },
  {
    name: 'Landlords & Agents',
    href: '/landlord-services',
    dropdown: [
      { name: 'Landlord Services', href: '/landlord-services' },
      { name: 'Letting Agent Maintenance', href: '/letting-agent-maintenance' },
      { name: 'End of Tenancy Repairs', href: '/end-of-tenancy' },
      { name: 'Void Property Works', href: '/void-property-works' }
    ]
  },
  {
    name: 'Homeowners',
    href: '/homeowner-services'
  },
  {
    name: 'Refurbishment',
    href: '/property-refurbishment'
  },
  {
    name: 'Areas',
    href: '#areas',
    dropdown: [
      { name: 'Manchester', href: '/property-maintenance-manchester' },
      { name: 'Stockport', href: '/property-maintenance-stockport' },
      { name: 'Didsbury', href: '/property-maintenance-didsbury' },
      { name: 'Cheadle', href: '/property-maintenance-cheadle' },
      { name: 'Altrincham', href: '/property-maintenance-altrincham' },
      { name: 'Sale', href: '/property-maintenance-sale' },
      { name: 'Salford', href: '/property-maintenance-salford' },
      { name: 'Wilmslow', href: '/property-maintenance-wilmslow' }
    ]
  },
  {
    name: 'Join Our Team',
    href: '/join',
    highlight: true
  }
];

// Logo URLs - Official Expert Property Maintenance logo
export const MASTER_LOGO_URL = "/brand/epm-logo-header.png";
export const EPM_MONOGRAM_URL = "https://customer-assets-lqy194kg.emergentagent.net/job_f637d394-69ad-4c84-81b1-378d0bfe728e/artifacts/kpay4epr_image.png";
